













import Vue from 'vue';
import { Month, MonthsWithDays } from '@/common/types/dateTime.types';
import { MonthRecurrenceModel } from '@/common/types/billingRecurrences.types';

export default Vue.extend({
  props: {
    value: {
      type: Object as () => MonthRecurrenceModel,
      required: true,
    },
  },
  data() {
    return {
      Month,
    };
  },
  methods: {
    getDays() {
      const last = MonthsWithDays.get(this.value.month);
      const days = [];
      for (let i:number = 1; i <= last; i += 1) {
        days.push(i);
      }
      return days;
    },
  },
});
